import { gql } from "@apollo/client";
import { FeedComponentInfo } from "./getFeedComponentsCall";

export const MAINTAIN_FEED_COMPONENTS_INFO = gql`
  mutation MaintainFeedComponent($domain: String!, $maintainFeedComponents: [FeedComponentInfoInput!]!) {
    feedComponent {
      maintain(domain: $domain, maintainFeedComponents: $maintainFeedComponents) {
        code
        success
        message
        updatedValues {
          id
          name
          readyMixture
          priority
          ds
          energy
          protein
          deleted
        }
      }
    }
  }
`;

export interface PanelMaintainFeedComponentsResponse {
  feedComponent: {
    maintain: MaintainPanelFeedComponent
  }
}

interface MaintainPanelFeedComponent {
  success: boolean;
  updatedValues: FeedComponentInfo[]
}